import React from "react";
import { X } from "lucide-react";

/** Checkbox multi-select with a search box (residents / staff); picked people show as removable chips. */
export default function PeoplePicker({ label, people, value, onChange, testid }) {
  const [q, setQ] = React.useState("");
  const list = people.filter((p) => p.name.toLowerCase().includes(q.toLowerCase()));
  const byId = Object.fromEntries(people.map((p) => [p.id, p.name]));
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <div data-testid={testid} className="border border-white/10 rounded-sm">
      <div className="flex items-center justify-between gap-2 px-2 py-1.5 border-b border-white/10">
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">{label} · {value.length} picked</span>
        <div className="flex items-center gap-2">
          {value.length > 0 && <button type="button" data-testid={`${testid}-clear`} onClick={() => onChange([])} className="text-[10px] font-mono uppercase text-nex-muted hover:text-white">Clear</button>}
          <input data-testid={`${testid}-search`} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search names" className="bg-white/5 px-2 py-1 text-xs text-white outline-none w-32 rounded-sm" />
        </div>
      </div>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1 px-2 py-1.5 border-b border-white/10" data-testid={`${testid}-chips`}>
          {value.map((id) => (
            <span key={id} className="inline-flex items-center gap-1 pl-2 pr-1 py-0.5 text-[11px] bg-nex-gold/15 text-nex-gold border border-nex-gold/30">
              {byId[id] || "Unknown"}
              <button type="button" aria-label="Remove" data-testid={`${testid}-chip-remove-${id}`} onClick={() => toggle(id)} className="hover:text-white"><X className="w-3 h-3" /></button>
            </span>
          ))}
        </div>
      )}
      <div className="max-h-52 overflow-y-auto p-1">
        {list.map((p) => (
          <label key={p.id} className="flex items-center gap-2 px-1.5 py-1.5 text-sm text-white/85 cursor-pointer hover:bg-white/5">
            <input type="checkbox" className="h-4 w-4" data-testid={`${testid}-opt-${p.id}`} checked={value.includes(p.id)} onChange={() => toggle(p.id)} /> {p.name}
          </label>
        ))}
        {!list.length && <div className="text-xs text-nex-muted px-1">None</div>}
      </div>
    </div>
  );
}
